import { useNavigate } from 'react-router-dom';
import { RoutesList } from '../../../routes/Routes';
import { useState } from 'react';
import { ErrorMessages } from '@types';
import { ZodError } from 'zod';
import { parseZodErrors } from '@utils';
import { detailOfIssueSchema } from '../../validations/index';
import { FormTitle, NavigationButtons, TextArea } from '@molecules/*';
import { ErrorSummary } from '@atoms/*';
import { useBuskingStore } from '../../../../hooks/useBuskingStore';
import { TEXT_AREA_MAX_LENGTH } from '@constants';

const pageTitle = 'Details of the issue';
const descriptionOfTheIssue = `
Please tell us more about the issue. For example, is the performer making excessive noise or in breach of condition?`;

const descriptionOfThePerformer = `For example, physical description, licence number, band or performer name or social media handle. Do not accuse or share private contact details of the performer.`;

export const IssueDetails = () => {
  const { data, get, update } = useBuskingStore();
  const [errorMessages, setErrorMessages] = useState<ErrorMessages[]>([]);
  const navigate = useNavigate();

  const handleDescribeTheIssue = (
    event: React.ChangeEvent<HTMLTextAreaElement>,
  ) => {
    update('describeTheIssue', event.currentTarget.value);
    setErrorMessages([]);
  };

  const handleDescribeThePerformer = (
    event: React.ChangeEvent<HTMLTextAreaElement>,
  ) => {
    update('describeThePerformer', event.currentTarget.value);
    setErrorMessages([]);
  };

  const buttonNext = {
    onClick: () => {
      try {
        detailOfIssueSchema.parse({
          describeTheIssue: get('describeTheIssue'),
          describeThePerformer: get('describeThePerformer'),
        });
        navigate(RoutesList.ISSUE_DATE_TIME);
      } catch (error) {
        const validationErrors = parseZodErrors(error as ZodError);
        setErrorMessages(
          validationErrors.map((error: ErrorMessages) => ({
            ...error,
            href: error.path,
          })),
        );
      }
    },
  };

  const buttonPrevious = {
    onClick: () => {
      navigate(RoutesList.ISSUE_TYPE);
    },
  };

  return (
    <>
      <ErrorSummary messages={errorMessages} />
      <FormTitle text={pageTitle} />
      <TextArea
        // set to errorPath so that click on the error message can navigate to the correct field
        labelText={'Details of the issue'}
        isLabelTextTitle={false}
        description={descriptionOfTheIssue}
        errorPath={'describeTheIssue'}
        errorMessages={errorMessages}
        onChange={handleDescribeTheIssue}
        maxLength={TEXT_AREA_MAX_LENGTH}
        value={data?.describeTheIssue}
      />
      <TextArea
        // set to errorPath so that click on the error message can navigate to the correct field
        labelText={'Describe the performer'}
        isLabelTextTitle={false}
        description={descriptionOfThePerformer}
        errorPath={'describeThePerformer'}
        errorMessages={errorMessages}
        onChange={handleDescribeThePerformer}
        maxLength={TEXT_AREA_MAX_LENGTH}
        value={data?.describeThePerformer}
      />
      <NavigationButtons
        buttonNext={buttonNext}
        buttonPrevious={buttonPrevious}
      />
    </>
  );
};
